import * as React from 'react'

import { Tag } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { ContractSchedule } from 'modules/contracts/lib/contractSchedule'

interface Props {
  schedule: string
  isHighlighted: boolean
}

const StatusTag = ({ schedule, isHighlighted }: Props) => {
  let status = i18n.t('contract_versions.navigator.header.status.ongoing')
  let tagType = Tag.Types.viridian

  if (schedule === ContractSchedule.upcoming) {
    status = i18n.t('contract_versions.navigator.header.status.upcoming')
    tagType = Tag.Types.champagne
  } else if (schedule === ContractSchedule.expired) {
    status = i18n.t('contract_versions.navigator.header.status.expired')
    tagType = Tag.Types.grey
  }

  return (
    <Tag type={tagType} solid={isHighlighted} inline>
      {status}
    </Tag>
  )
}

export default observer(StatusTag)
